const {getShoppingCartProductName} = require('./utils');

const processIds = ([policy, id] = []) => ({
    ...(policy && {policy}),
    ...(id && {id}),
});

module.exports = {
    decorate: (data = {}) => data,
    processIds,
    getProductName: getShoppingCartProductName,
};
